import {
  Body,
  Box,
  Button,
  Image,
  VStack,
  motion,
  useTheme,
} from '@hover/blueprint';
import React, { useEffect } from 'react';

import { AnimatedFullWidthContainer } from 'src/modules/pro/components/FullWidthContainer';
import { useProPageContext } from 'src/modules/pro/hooks/useProPageContext';
import { useDisappearingHeaderOnScroll } from 'src/shared/hooks/useDisappearingHeaderOnScroll';
import { buttonPressed } from 'src/shared/telemetry';

import { useProTranslate } from '../hooks';

const MotionButton = motion(Button);

export const Header = () => {
  const t = useProTranslate();
  const { zIndices } = useTheme();
  const { headerRef, topAdjustedComponentControls, headerControls } =
    useDisappearingHeaderOnScroll();

  const {
    leadFormRef,
    leadSubmitted,
    isLeadFormVisible,
    brandLogoUrl,
    orgDisplayName,
    genericTrackingData,
    setHeaderOffsetControls,
  } = useProPageContext();

  useEffect(() => {
    setHeaderOffsetControls(topAdjustedComponentControls);
  }, [topAdjustedComponentControls, setHeaderOffsetControls]);

  const hideGetInTouch = leadSubmitted || isLeadFormVisible;

  const scrollToLeadFormContainer = () => {
    buttonPressed({
      ...genericTrackingData,
      button_text: 'Get in touch',
      button_location: 'top nav',
      track_id: 'get-in-touch-click',
    });
    if (leadFormRef) {
      leadFormRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AnimatedFullWidthContainer
      animate={headerControls}
      background="neutral.0"
      position="sticky"
      ref={headerRef}
      top={0}
      zIndex={zIndices.banner}
    >
      <Box
        alignItems="center"
        flexDirection="row"
        height={{ base: 500, tablet: 600 }}
        justifyContent="space-between"
        paddingY={{ base: 200, tablet: 600 }}
        w={1}
      >
        <VStack spacing={100}>
          {brandLogoUrl && (
            <Image
              alignSelf="flex-start"
              alt={t('navBar.logoAlt', { name: orgDisplayName })}
              maxHeight={400}
              maxWidth={600}
              src={brandLogoUrl}
            />
          )}
          <Body
            color="neutral.600"
            size={{ base: 'footnote', tablet: 'medium' }}
          >
            {t('navBar.poweredByHover')}
          </Body>
        </VStack>
        <MotionButton
          animate={!hideGetInTouch ? 'show' : 'hide'}
          initial="show"
          onClick={scrollToLeadFormContainer}
          transition={{ duration: 0.1 }}
          variant="secondary"
          variants={{
            hide: { opacity: 0 },
            show: { opacity: 1 },
          }}
        >
          {t('getInTouch')}
        </MotionButton>
      </Box>
    </AnimatedFullWidthContainer>
  );
};
